import { graphql } from '@/gql'
import { DeleteDialog, type Props } from '../delete_dialog'
import { useNavigate } from 'react-router'

const DestroyItemTypeMutation = graphql(`
  mutation DestroyItemType($id: ID!) {
    destroyItemType(input: { id: $id }) {
      itemType { id }
      errors { path message }
    }
  }
`)

export const Delete = ({ id, open, setOpen, refetchQueries }: Omit<Props<never>, 'mutation' | 'onSuccess'>) => {
  const navigate = useNavigate()

  return (
    <DeleteDialog
      id={ id }
      mutation={ DestroyItemTypeMutation }
      open={ open }
      refetchQueries={ refetchQueries }
      setOpen={ setOpen }
      onSuccess={ () => navigate('/item_types') }
    />
  )
}
